// Activation.js
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getActivationData } from '../services/apiCalls';

function Activation() {
	const [status, setStatus] = useState('idle'); // idle | loading | success | error
	const navigate = useNavigate();

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const activationCode = params.get('code');

		if (!activationCode) {
			setStatus('error');
			return;
		}

		activate(activationCode);
	}, []);

	const activate = async (activationCode) => {
		setStatus('loading');

		try {
			const data = await getActivationData({ activationCode });
			window.localStorage.setItem('activationData', JSON.stringify(data));
			window.localStorage.setItem('activationCode', activationCode);
			window.dispatchEvent(new Event('activationDataUpdated'));
			setStatus('success');
			navigate('/subscriptions');
		} catch (err) {
			console.error('Activation failed', err);
			setStatus('error');
		}
	};

	if (status !== 'loading') return null;

	return (
		<div style={{
			padding: "2rem",
			textAlign: "center",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			gap: "1rem"
		}}>
			<div
				className='spinner'
			/>

			{/* Inline <style> to define animation */}
			<style>
				{`
				@keyframes spin {
					to { transform: rotate(360deg); }
				}
				`}
			</style>
		</div>
	);
}

export default Activation;